const twoDigitFormat = ( value ) => ( value < 10 ) ? `0${ value }` : value;
export default twoDigitFormat